<div class="payment-screen" (click)="waitingForPayment && skipToNextStep()" [style.cursor]="waitingForPayment ? 'pointer' : 'default'">
  <article>
    <h1>Procesando pago...</h1>
    <div *ngIf="loading" class="loading-container">
      <p>Preparando tu método de pago...</p>
    </div>
    <div *ngIf="waitingForPayment && !error" class="waiting-container">
      <p>Esperando confirmación del pago...</p>
      
    </div>
    <div *ngIf="error" class="error-container">
      <p>{{ error }}</p>
      <button (click)="initiatePayment(); $event.stopPropagation()">Reintentar</button>
    </div>
  </article>
</div>
